import api from "api/";
import { API_Type } from "hooks/listAll";

export const API_PAGE_SIZE = 100;
const PAGE_FETCH_CONCURRENCY = 2;

export const getAllPagesBody = async <T>(
  type: API_Type,
  pageSize = API_PAGE_SIZE,
  options: Record<string, unknown> = {}
) => {
  const firstPage = await api.client?.[type].list({
    ...options,
    page: 1,
    size: pageSize,
  });
  const parsedTotalPages = Number.parseInt(
    firstPage?.headers?.["total-pages"] ?? "1",
    10
  );
  const totalPages = Number.isNaN(parsedTotalPages)
    ? 1
    : Math.max(parsedTotalPages, 1);

  const allPagesBody = [...(firstPage?.body ?? [])];
  for (let page = 2; page <= totalPages; page += PAGE_FETCH_CONCURRENCY) {
    const pages = await Promise.all(
      Array.from(
        { length: Math.min(PAGE_FETCH_CONCURRENCY, totalPages - page + 1) },
        (_, index) => api.client?.[type].list({
          ...options,
          page: page + index,
          size: pageSize,
        })
      )
    );
    allPagesBody.push(...pages.flatMap((response) => response?.body ?? []));
  }

  return allPagesBody as T[];
};
